var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpeningQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 120,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.97 120H0V70.735c0-18.137 3.775-32.45 11.323-42.94C18.873 17.303 31.813 8.038 50.147 0l13.824 26.177C52.696 31.47 44.902 36.764 40.588 42.059c-4.313 5.196-6.715 11.372-7.206 18.53h30.589V120zm74.559 0h-63.97V70.735c0-18.137 3.774-32.45 11.323-42.94C93.432 17.303 106.373 8.038 124.706 0l13.823 26.177c-11.274 5.294-19.068 10.588-23.382 15.882-4.314 5.196-6.716 11.372-7.206 18.53h30.588V120z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpeningQuote);
export default __webpack_public_path__ + "static/media/opening-quote.2cf8602dc5d4b4617dd7926d6a121c0d.svg";
export { ForwardRef as ReactComponent };